import { useEffect, useState } from "react";
import { FormBankAccount } from "../forms/formBankAccount";
import { BasicInfoService } from "../../services/basicinfo/basicinfo.service";
import { sanitizarInputNumerico } from "../../utils/validateData";
import {
  contieneCaracteresPeligrosos,
  validarLongitudMaxima,
} from "../../utils/validacionesForms";
import { BottomSheet } from "../new_components/BottomSheet";
import { NextButton } from "../new_components/buttonsFlow";
import { reintentarUsuarioComments } from "../../utils/commentsValidate";
import * as url from "../../helpers/url_helper";
import { APIClient } from "../../helpers/api_helper";

const apiClient = new APIClient();

export function AddBankAccountDialog({
  dialogOpen,
  setDialogOpen,
  _state,
  setState,
  refreshAccounts,
  features,
  handleOpenAlert,
}) {
  const [errorField, setErrorField] = useState({});
  const [disableBtn, setDisableBtn] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  const clearStateBankAccount = () => {
    setState({
      bankAccount: "",
      typeBankAccount: "",
      accountNumber: "",
      parent: false,
    });
  };

  const handleOpenSnackbar = (type, message) => {
    handleOpenAlert(type, message);
  };

  const handleToggleDialog = () => {
    if (dialogOpen) {
      setDialogOpen(false);
    } else {
      setDialogOpen(true);
    }
    setErrorField({});
    clearStateBankAccount();
  };

  const validateData = () => {
    // MITIGACIÓN VUL-03: Validar longitud máxima (Buffer Overflow)
    const MAX_ACCOUNT_LENGTH = 15;
    if (
      validarLongitudMaxima(_state.accountNumber, MAX_ACCOUNT_LENGTH) === false
    ) {
      handleOpenSnackbar(
        "error",
        `El número de cuenta no puede superar los ${MAX_ACCOUNT_LENGTH} dígitos.`,
      );
      return false;
    }

    // MITIGACIÓN VUL-03: Validar Inyección (Solo números permitidos)
    const soloNumerosRegex = /^[0-9]+$/;
    if (!soloNumerosRegex.test(_state.accountNumber)) {
      handleOpenSnackbar(
        "error",
        "El número de cuenta contiene caracteres inválidos.",
      );
      return false;
    }

    // MITIGACIÓN VUL-03: Validar que el Banco y Tipo no tengan inyecciones
    if (
      contieneCaracteresPeligrosos(_state.bankAccount) ||
      contieneCaracteresPeligrosos(_state.typeBankAccount)
    ) {
      handleOpenSnackbar("error", "Datos de banco inválidos.");
      return false;
    }

    const newErrors = {};
    let hasValidate = true;
    if (
      _state.typeBankAccount === "Seleccione una opción." ||
      _state.typeBankAccount === ""
    ) {
      newErrors.typeBankAccount = "Debe seleccionar una opción válida.";
    } else if (_state.accountNumber.length === 0) {
      newErrors.accountNumber = "Ingrese un número de cuenta válido.";
    } else if (
      _state.bankAccount === "Seleccione una opción." ||
      _state.bankAccount === ""
    ) {
      newErrors.bankAccount = "Debe seleccionar una opción válida.";
    }
    if (Object.keys(newErrors).length > 0) {
      setErrorField(newErrors);
      hasValidate = false;
    } else {
      setErrorField({});
    }
    return hasValidate;
  };

  const handlesubmit = async () => {
    try {
      setDisableBtn(true);
      let __error;
      let __message;
      let hasValidate = validateData();
      if (!hasValidate) return;
      _state.accountNumber = sanitizarInputNumerico(_state?.accountNumber);

      if (_state.parent === true) {
        let { id } = features.filter((feat) => feat.check === true)[0];
        let { error, message } = await BasicInfoService.addPrincipalBankAccount(
          {
            documento: localStorage.getItem("doc"),
            bankAccount: _state,
            idPrincipal: id,
          },
        );
        __error = error;
        __message = message;
      } else {
        let { error, message } = await BasicInfoService.addBankAccount({
          documento: localStorage.getItem("doc"),
          bankAccount: _state,
        });
        __error = error;
        __message = message;
      }

      if (__error) {
        return handleOpenSnackbar(
          "error",
          __message?.message ||
            "Ha ocurrido un error inesperado, por favor intenta más tarde.",
        );
      } else {
        handleOpenSnackbar("success", "¡Hemos agregado tu banco con éxito!.");
        let disbursementComment = localStorage.getItem("disbursementComment");
        let disbursementId = localStorage.getItem("disbursementId");
        let disbursementStatus = localStorage.getItem("disbursementStatus");
        let credit_id = localStorage.getItem("credit_id");
        await refreshAccounts();
        if (
          reintentarUsuarioComments.includes(disbursementComment) &&
          disbursementStatus === "Fallido" &&
          _state.parent === true
        ) {
          retryDisbursement(disbursementId, credit_id);
        }
      }
      if (dialogOpen) {
        setDialogOpen(false);
      } else {
        setDialogOpen(true);
      }
      clearStateBankAccount();
      return;
    } catch (error) {
      console.error(error?.message);
    } finally {
      setDisableBtn(false);
    }
  };

  const retryDisbursement = async (disbursement_id, credit_id) => {
    try {
      if (!credit_id) return {};
      const { data } = await apiClient.put(url.RETRY_DISBURSEMENT, {
        idcredito: disbursement_id,
        iddesembolso: credit_id,
      });
      let _disbursementData = data?.data;
      if (_disbursementData?.success) return _disbursementData ?? {};
    } catch (error) {
      console.error(error);
      return {};
    }
  };

  useEffect(() => {
    const checkIfMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkIfMobile();
    window.addEventListener("resize", checkIfMobile);

    return () => window.removeEventListener("resize", checkIfMobile);
  }, []);

  return (
    <>
      <BottomSheet
        open={dialogOpen}
        isDesktop={!isMobile}
        onOpenChange={handleToggleDialog}
        headerContent={
          <div>
            <h1 className="font-semibold2 text-xl">Agregar cuenta bancaria</h1>
          </div>
        }
        footerContent={
          <div className="flex items-center justify-center gap-5 h-16">
            <NextButton
              finishLabel={"Agregar banco"}
              isLastStep={true}
              showIconNext={false}
              onNext={(e) => {
                handlesubmit(e);
              }}
              disabled={disableBtn}
              isUnicButtom={true}
            />
          </div>
        }
      >
        <div className="mt-2 flex flex-col items-center">
          <p className="font-semibold2 text-lg text-center">
            La cuenta bancaria que agruegues la puedes seleccionar para que te
            llegue el dinero a partir del próximo crédito.
          </p>
          <FormBankAccount
            _state={_state}
            setState={setState}
            errorField={errorField}
          ></FormBankAccount>
        </div>
      </BottomSheet>
    </>
  );
}
